import PostItem from "../home/patsPosts_item";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

function Post() {
  const [singlePost, setSinglePost] = useState(null);
  let { id } = useParams();

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "api/post/" + id)
      .then((response) => response.json())
      .then((data) => {
        if (data.issuccessful == true) {
          setSinglePost(data.posts[0]);
        } else {
          alert.error(data.message);
        }
      });
  }, [id]);



  if (singlePost !== null) {
    return (
      <>
    
      <PostItem data={singlePost} key={singlePost.postID} />
      </>
      //<h1>Not empty</h1>
    );
  } else {
    return (
      //<PostItem data={singlePost} key={1} />
      <h5>Loading...</h5>
    );
  }
}
export default Post;
